var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videoChats.length)?_c('div',{staticClass:"video-chats"},[(_vm.hasAccessToDevices)?_vm._l((_vm.videoChats),function(chat){return _c('VideoChat',{key:chat.id,attrs:{"chat":chat}})}):_c('AccessToDevicesDialog')],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }